import { useMemo } from 'react';
import { getCampaignNameValidationError } from '../utils/campaignName';
import { useDebounce } from './useDebounce';
const DEBOUNCE_TIME = 500;
export function getCanCampaignNameBeSaved(name) {
  return !!name.trim() && !getCampaignNameValidationError(name);
}
export default function useCampaignNameValidation(name = '', customValidationMessages) {
  const debouncedName = useDebounce(name, DEBOUNCE_TIME);
  const debouncedCustomValidationMessages = useDebounce(customValidationMessages, DEBOUNCE_TIME);
  const campaignNameValidationError = getCampaignNameValidationError(debouncedName, debouncedCustomValidationMessages);
  return useMemo(() => ({
    canCampaignNameBeSaved: debouncedName !== '' && !campaignNameValidationError,
    isCampaignNameValid: !campaignNameValidationError,
    campaignNameValidationError
  }), [debouncedName, campaignNameValidationError]);
}